/**
 * Onboard-club responses may include credentials_sheet_log when the backend
 * attempted (or skipped) a Google Sheets append. Surface failures to ops.
 *
 * @param {Record<string, unknown> | null | undefined} result - onboardClub() response body
 * @param {{ error: (msg: string) => void }} toast - e.g. sonner
 */
export function notifyIfOnboardCredentialsSheetFailed(result, toast) {
  const log = result?.credentials_sheet_log;
  if (!log || typeof log !== "object" || Array.isArray(log)) return;
  const status = log.status;
  if (status !== "failed") return;
  const detail =
    typeof log.detail === "string" && log.detail.trim() ? log.detail.trim() : "Check backend logs (onboard_club_sheet:).";
  toast.error(`Club onboarded, but the logins sheet append failed: ${detail}`);
}
